import { useState } from 'react';
import classNames from 'classnames';
import { NavLink, useLocation } from 'react-router-dom';

import isDesktop from 'helpers/isDesktop';
import Menu from 'sections/menu';

import { navItems, excludedRoutes } from './config';

import 'assets/styles/mobile/navigation.scss';

function Navigation() {
  const location = useLocation();
  const [isMenuOpened, setIsMenuOpened] = useState(false);

  if (excludedRoutes.includes(location.pathname)) return null;

  const handleItemClick = () => {
    setIsMenuOpened(false);
  };

  return (
    <>
      <nav className="nav-b">
        {navItems.map(({ name, link, iconName, exact }) => {
          const isInTheSameRoute = exact
            ? link === location.pathname
            : location.pathname.startsWith(link);

          return (
            <NavLink
              disabled
              to={link}
              key={name}
              exact={exact}
              activeClassName="active"
              onClick={() => setIsMenuOpened(false)}
              className={classNames('nav-item', { disabled: isInTheSameRoute })}
            >
              <i className={iconName} />
            </NavLink>
          );
        })}
        {!isDesktop && (
          <a className="nav-item">
            {isMenuOpened ? (
              <i className="icon-closed" onClick={() => setIsMenuOpened(false)} />
            ) : (
              <i className="icon-burger" onClick={() => setIsMenuOpened(true)} />
            )}
          </a>
        )}
      </nav>
      <Menu isOpen={isMenuOpened} onItemClick={handleItemClick} />
    </>
  );
}

export default Navigation;
